"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEmptyParameter = void 0;
const types_1 = require("@framework/types");
const utils_1 = require("./utils");
const getEmptyParameter = props => {
    const availableParameterNames = (0, utils_1.getAvailableNames)(props);
    const parameterName = availableParameterNames ? availableParameterNames[0] : null;
    if (!parameterName) {
        return null;
    }
    return {
        parameterName,
        parameterType: types_1.ParameterType.NUMBER,
        parameterValue: "0",
        parameterMinValue: "1",
        parameterMaxValue: "5",
    };
};
exports.getEmptyParameter = getEmptyParameter;
//# sourceMappingURL=empty.js.map